import { Select } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import { GET_VOICE_AGENTS } from 'src/graphql/voiceAgents.graphql'
import { formatSnakeValue } from 'src/lib/formatters'

import { inlineSelectProps } from './inlineSelectStyles'

const VoiceAgentOptions = ({ selectedVoiceAgent, setSelectedVoiceAgent }) => {
  const { data: voiceAgents } = useQuery(GET_VOICE_AGENTS, {
    variables: {
      pageInfo: {
        limit: 100,
        offset: 0,
      },
    },
  })

  const voiceAgentList =
    voiceAgents?.voiceAgents?.items?.map((voiceAgent) => ({
      value: voiceAgent.voiceAgentId,
      label: `${formatSnakeValue(voiceAgent.direction)} - ${voiceAgent.name}`,
    })) || []

  return (
    <div className="flex flex-col gap-3 text-xs">      {voiceAgentList.length === 0 ? (
        <div className="text-xs text-doubleNickel-gray-500">
          No voice agents found.
        </div>
      ) : (
        <Select
          {...inlineSelectProps}
          value={selectedVoiceAgent?.voiceAgentId}
          onChange={(value) => setSelectedVoiceAgent({ voiceAgentId: value })}
          data={voiceAgentList}
          className="max-w-sm"
          searchable
        />
      )}
    </div>
  )
}

export default VoiceAgentOptions
